var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.902,
    height: 25.367,
    viewBox: "0 0 43.902 25.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "registered",
    transform: "translate(-5 -21.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37858",
    "data-name": "Group 37858",
    transform: "translate(5 21.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65230",
    "data-name": "Path 65230",
    d: "M7.927,973.4A2.92,2.92,0,0,0,5,976.328V995.84a2.92,2.92,0,0,0,2.927,2.927H45.975A2.92,2.92,0,0,0,48.9,995.84V976.328a2.92,2.92,0,0,0-2.927-2.927Zm9.759,6.343a2.927,2.927,0,1,1-2.927,2.927,2.927,2.927,0,0,1,2.927-2.927Zm11.215,0H44.022a.976.976,0,1,1,0,1.952H28.9a.976.976,0,0,1,0-1.952Zm0,5.366H44.022a.976.976,0,1,1,0,1.952H28.9a.976.976,0,0,1,0-1.952Zm-11.215,2.439c3.513,0,6.343,1.868,6.343,4.07v.808H11.343v-.808c0-2.2,2.827-4.071,6.343-4.071ZM28.9,990.473H44.022a.976.976,0,1,1,0,1.952H28.9a.976.976,0,1,1,0-1.952Z",
    transform: "translate(-5 -973.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/registered.40767e9dc8b873fc5f082c263996d0b1.svg";
export { ForwardRef as ReactComponent };